var _path, _path2, _ellipse, _path3, _path4, _rect, _rect2, _ellipse2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoInline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 305,
    height: 97,
    viewBox: "0 0 305 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.9 79.75C195.22 81.57 192.78 82.48 189.58 82.48C186.38 82.48 183.94 81.57 182.26 79.75C180.58 77.93 179.74 75.32 179.74 71.92V50.08C179.74 46.68 180.58 44.07 182.26 42.25C183.94 40.43 186.38 39.52 189.58 39.52C192.78 39.52 195.22 40.43 196.9 42.25C198.58 44.07 199.42 46.68 199.42 50.08V54.16H193.18V49.66C193.18 46.9 192.04 45.52 189.76 45.52C187.48 45.52 186.34 46.9 186.34 49.66V72.34C186.34 75.06 187.48 76.42 189.76 76.42C192.04 76.42 193.18 75.06 193.18 72.34V64.6H190.18V58.6H199.42V71.92C199.42 75.32 198.58 77.93 196.9 79.75ZM129.22 82C132.5 82 134.96 81.12 136.6 79.36C138.24 77.6 139.06 75.02 139.06 71.62V50.38C139.06 46.98 138.24 44.4 136.6 42.64C134.96 40.88 132.5 40 129.22 40H118.78V82H129.22ZM129.1 76H125.38V46H129.1C130.18 46 131.01 46.32 131.59 46.96C132.17 47.6 132.46 48.64 132.46 50.08V71.92C132.46 73.36 132.17 74.4 131.59 75.04C131.01 75.68 130.18 76 129.1 76ZM149.86 40V82H143.26V40H149.86ZM160.54 82V51.58L168.76 82H175.54V40H169.66V65.14L162.88 40H154.6V82H160.54ZM213.16 82.48C216.4 82.48 218.88 81.56 220.6 79.72C222.32 77.88 223.18 75.28 223.18 71.92V50.08C223.18 46.72 222.32 44.12 220.6 42.28C218.88 40.44 216.4 39.52 213.16 39.52C209.92 39.52 207.44 40.44 205.72 42.28C204 44.12 203.14 46.72 203.14 50.08V71.92C203.14 75.28 204 77.88 205.72 79.72C207.44 81.56 209.92 82.48 213.16 82.48ZM209.74 72.34C209.74 75.1 210.88 76.48 213.16 76.48C215.44 76.48 216.58 75.1 216.58 72.34V49.66C216.58 46.9 215.44 45.52 213.16 45.52C210.88 45.52 209.74 46.9 209.74 49.66V72.34Z",
    fill: "#282837"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.8 40L251.32 82H241.48L235 40H241.66L246.7 74.26L251.74 40H257.8ZM267.46 66.22V82H260.86V40H270.58C273.86 40 276.32 40.88 277.96 42.64C279.6 44.4 280.42 46.98 280.42 50.38V55.84C280.42 59.24 279.6 61.82 277.96 63.58C276.32 65.34 273.86 66.22 270.58 66.22H267.46ZM270.58 60.22H267.46V46H270.58C271.66 46 272.47 46.3 273.01 46.9C273.55 47.5 273.82 48.52 273.82 49.96V56.26C273.82 57.7 273.55 58.72 273.01 59.32C272.47 59.92 271.66 60.22 270.58 60.22ZM289.66 51.58V82H283.72V40H292L298.78 65.14V40H304.66V82H297.88L289.66 51.58Z",
    fill: "#FFBB00"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30,
    cy: 87,
    rx: 30,
    ry: 10,
    fill: "#282837"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 93.4938C7 93.4938 9.06475 63.3452 9.12916 53.9218C9.37419 18.0725 7.11906 -0.0815157 14.7468 0.0074725C19.3755 0.0613788 21.6263 14.0036 29.9032 24.6967C31.1248 26.275 31.3316 23.9557 41.5561 23.9557C48.8536 23.9557 48.5076 26.275 49.6526 24.6967C54.0676 18.6113 54.0495 -0.431713 62.8366 0.0074725C67.97 0.264043 67.4767 25.2127 67.4767 52.2481C67.4767 54.496 95.5016 56.8801 93.9368 66.7356C92.3721 76.5911 52.9486 79.8467 52.9486 79.9376C52.9486 80.2888 54.12 92.9584 54.12 92.9584C54.12 92.9584 46.133 97 31.1248 97C16.1166 97 7 93.4938 7 93.4938Z",
    fill: "url(#paint0_linear_6_56)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58 70.9822C58 70.9822 54.5199 72.6184 51.0908 71.6242C47.6616 70.63 47 68 47 68",
    stroke: "#95651D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.3784,
    y: 40.2366,
    width: 17.3235,
    height: 10.4211,
    rx: 2,
    fill: "#282837"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 54.4961,
    y: 40.2366,
    width: 17.3235,
    height: 10.4211,
    rx: 2,
    fill: "#282837"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.5,
    cy: 67.5,
    rx: 6.5,
    ry: 4.5,
    fill: "#95651D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_56",
    x1: 7,
    y1: 0,
    x2: 7,
    y2: 97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8600"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoInline);
export default __webpack_public_path__ + "static/media/logo_inline.997dc66a93abefce55d3ffdb2aec6b9d.svg";
export { ForwardRef as ReactComponent };